// Словарь интерфейса (O'zbekcha). Ключ = либо смысловой (nav.*, col.*), либо английский оригинал.
const uz = {
  // Выгрузка набора данных
  "Export dataset": "Ma'lumotlar to'plamini yuklab olish",
  "Export dataset hint": "Razmetka arxivi tayyorlanadi: segmentli JSONL, CSV jadvallar va hisobot. Tayyorlash serverda ketadi, biroz vaqt olishi mumkin.",
  "Export format": "Nimani yuklab olish",
  "Export format full": "To'liq to'plam: JSONL, segmentlar bo'yicha CSV, hisobot",
  "Export format markup": "audio,text jadvali — kirish razmetka faylidagidek (shu dataset)",
  "Export format markup hint": "Har bir faylga bitta qator, fayl yo'llari — dastlabki jadvaldagidek. Matn eng so'nggi o'tilgan bosqichdan olinadi: yakuniy tekshirish, tekshirish, razmetka.",
  "Export layer": "Qaysi matn",
  "Export layer verbatim": "So'zma-so'z (L1)",
  "Export layer normalized": "Normallashtirilgan (L2)",
  "Include audio files": "Audio fayllarni qo'shish",
  "Include audio warning": "Audio bilan arxiv katta bo'ladi (bir necha GB) va uzoqroq tayyorlanadi.",
  "Prepare export": "Tayyorlash",
  "Export ready": "Yuklab olishga tayyor",
  "Export failed": "Yuklab olishni tayyorlab bo'lmadi",
  "Nothing to export": "Yuklab olish uchun ma'lumot yo'q: topshirilgan razmetka yo'q",
  "Queued": "Navbatda",
  "Collecting records": "Yozuvlar yig'ilmoqda",
  "Writing files": "Fayllar yozilmoqda",
  "Packing archive": "Arxiv tayyorlanmoqda",
  "records": "yozuv",
  "segments": "segment",

  // jadval yozuvlari (MUIDataTable)
  "Rows per page:": "Sahifadagi satrlar:",
  "of": "dan",
  "Next Page": "Keyingi sahifa",
  "Previous Page": "Oldingi sahifa",
  "No records": "Ma'lumot yo'q",
  "Sorry, no matching records found": "Hech narsa topilmadi",
  "View Columns": "Ustunlar",
  "Sort": "Saralash",
  "Jump to page:": "Sahifaga o'tish:",
  "Download CSV": "CSV yuklab olish",
  "Print": "Chop etish",
  "FILTERS": "FILTRLAR",
  "RESET": "TOZALASH",
  "Show Columns": "Ustunlarni ko'rsatish",
  "row(s) selected": "qator tanlandi",
  "Delete Selected Rows": "Tanlangan qatorlarni o'chirish",
  landlingPageLabel: "CSI Annotator",
  enterEmailId: "Email kiriting*",
  enterPassword: "Parol kiriting*",
  forgotPassword: "Parolni unutdingizmi?",
  newPassword: "Yangi parol kiriting*",
  currentPassword: "Joriy parol kiriting*",
  "label.appInfo": "CSI Annotator — audio ma'lumotlarni belgilash va transkripsiya platformasi.",
  "button.cancel": "Bekor qilish",
  "button.notes": "Izohlar",
  "button.draft": "Qoralama",
  "button.next": "Keyingi",
  "button.skip": "O'tkazib yuborish",
  "button.submit": "Yuborish",
  "button.uploadData": "Ma'lumot yuklash",
  "button.downloadDataset": "To'plamni yuklab olish",
  "button.addNewWorkspace": "Ish maydoni qo'shish",
  "button.deleteDataItems": "Ma'lumot elementini o'chirish",
  "label.workspaces": "Ish maydonlari",
  "label.members": "A'zolar",
  "label.annotators": "Annotatorlar",
  "label.reviewers": "Tekshiruvchilar",
  "label.managers": "Menejerlar",
  "label.invites": "Takliflar",
  "label.settings": "Sozlamalar",
  "label.logs": "Jurnal",
  "label.tasks": "Vazifalar",
  "label.annotationTasks": "Annotatsiya vazifalari",
  "label.reviewTasks": "Tekshirish vazifalari",
  "label.reports": "Hisobotlar",
  "label.projectanalytics": "Loyiha tahlili",
  "label.projects": "Loyihalar",
  "label.datasets": "Ma'lumot to'plamlari",
  "label.analytics": "Tahlil",
  "label.backToPreviousPage": "Orqaga",
  "label.showProjectSettings": "Loyiha sozlamalari",
  "label.backToProject": "Loyihaga qaytish",

  "nav.organization": "Tashkilot",
  "nav.admin": "Admin",
  "menu.myProfile": "Mening profilim",
  "menu.myProgress": "Mening jarayonim",
  "menu.changePassword": "Parolni o'zgartirish",
  "menu.logout": "Chiqish",
  "menu.signedInAs": "Kirdingiz:",
  "tooltip.notifications": "Bildirishnomalar",
  "tooltip.userOptions": "Foydalanuvchi menyusi",

  "login.title": "CSI Annotator'ga kirish",
  "login.button": "Kirish",

  "common.view": "Ochish",
  "common.search": "Qidirish",
  "common.action": "Amal",
  "common.actions": "Amallar",
  "common.status": "Holat",
  "common.name": "Nomi",
  "common.id": "ID",
  "common.noRecords": "Ma'lumot yo'q",
  "common.rowsPerPage": "Sahifadagi satrlar:",
  "common.jumpToPage": "Sahifaga o'tish:",
  "common.createdBy": "Yaratgan",
  "view.list": "Ro'yxat",
  "view.card": "Kartochka",
  "view.label": "Ko'rinish:",

  "col.projectId": "Loyiha ID",
  "col.projectTitle": "Loyiha nomi",
  "col.projectType": "Loyiha turi",
  "col.projectStage": "Ish sxemasi",
  "col.targetLanguage": "Til",
  "col.workspaceId": "Ish maydoni ID",
  "col.domain": "Soha",
  "col.scenario": "Ssenariy",
  "col.audioDuration": "Audio davomiyligi",
  "col.referenceRawTranscript": "Namunaviy transkripsiya",
  "col.annotatorEmail": "Annotator email",

  "proj.addNewAnnotationProject": "Yangi annotatsiya loyihasi",
  "proj.pullNewBatch": "Vazifalar paketini olish",
  "proj.pullSize": "Paket hajmi",
  "proj.startLabelling": "Annotatsiyani boshlash",
  "proj.review": "Tekshirish",
  "proj.annotate": "Belgilash",

  "editor.speakerDetails": "So'zlovchilar ma'lumoti",
  "editor.provideTranscription": "Transkripsiya kiriting",
  "editor.verbatim": "So'zma-so'z transkripsiya",
  "editor.semanticL2": "Normallashtirilgan (L2) transkripsiya",
  "editor.selectSpeaker": "So'zlovchini tanlang",
  "editor.selectNoiseTag": "Shovqin belgisi",
  "editor.update": "Saqlash",
  "editor.accept": "Qabul qilish",
  "editor.revise": "Qaytarish",
  "editor.glossary": "Lug'at",

  "create.title": "Loyiha yaratish",
  "create.createProject": "Loyiha yaratish",
  // --- sanab o'tilgan qiymatlar (ko'rsatish; ma'lumotda original qoladi) ---
  "FULL_TIME": "To'liq bandlik",
  "PART_TIME": "Qisman bandlik",
  "CONTRACT_BASIS": "Shartnoma asosida",
  "NA": "Ko'rsatilmagan",

  // --- amallar / tugmalar ---
  "Required": "Majburiy",
  "Cancel": "Bekor qilish",
  "Submit": "Yuborish",
  "Confirm": "Tasdiqlash",
  "Confirm Selections": "Tanlovni tasdiqlash",
  "Save": "Saqlash",
  "Save task for later": "Qoralama sifatida saqlash",
  "Add": "Qo'shish",
  "Add New Item": "Element qo'shish",
  "Remove": "O'chirish",
  "Delete": "O'chirish",
  "Update": "Saqlash",
  "Updata": "Saqlash",
  "Close": "Yopish",
  "Copy": "Nusxalash",
  "Copy Text": "Matnni nusxalash",
  "Download": "Yuklab olish",
  "Export": "Eksport",
  "Import HTML Table": "HTML jadvalni import qilish",
  "Export HTML Table": "HTML jadvalni eksport qilish",
  "Validate": "Tasdiqlash",
  "Reject": "Rad etish",
  "Approve": "Tasdiqlash",
  "Resend": "Qayta yuborish",
  "Change": "O'zgartirish",
  "Edit Profile": "Profilni tahrirlash",
  "Update Profile": "Profilni saqlash",
  "View": "Ochish",
  "View Profile": "Profilni ochish",
  "Back": "Orqaga",
  "Reset": "Tiklash",
  "Apply": "Qo'llash",
  "Search": "Qidirish",
  "Filter Table": "Jadval filtri",
  "Filter Labels": "Belgilar filtri",
  "Clear Selection": "Tanlovni bekor qilish",
  "Verify": "Tasdiqlash",
  "Verify Email": "Emailni tasdiqlash",
  "Send link": "Havola yuborish",
  "Pin": "Mahkamlash",
  "Count": "Soni",
  "All": "Barchasi",
  "None": "Yo'q",
  "More": "Yana",
  "Type": "Turi",
  "Status": "Holat",
  "Action": "Amal",
  "Actions": "Amallar",
  "Name": "Nomi",
  "Id": "ID",
  "Description": "Tavsif",
  "Title": "Nomi",
  "Domain": "Soha",
  "Language": "Til",
  "Languages": "Tillar",
  "Role": "Rol",
  "Email": "Email",
  "Phone": "Telefon",
  "Username": "Foydalanuvchi nomi",
  "UserName": "Foydalanuvchi nomi",
  "Password": "Parol",
  "First Name": "Ism",
  "Last Name": "Familiya",
  "Created By": "Yaratgan",
  "Manager": "Menejer",
  "Owner": "Egasi",
  "Details": "Batafsil",
  "Color": "Rang",
  "Tag": "Belgi",
  "Chip": "Chip",
  "Editable": "Tahrirlanadi",
  "Disabled": "O'chirilgan",
  "Available": "Mavjud",
  "Unavailable": "Mavjud emas",
  "Active": "Faol",
  "Not Active": "Faol emas",
  "Active Status": "Faollik holati",
  "Availability Status": "Mavjudlik holati",

  // --- navigatsiya / rollar ---
  "Organization": "Tashkilot",
  "Organization Settings": "Tashkilot sozlamalari",
  "Projects": "Loyihalar",
  "Project": "Loyiha",
  "Workspace": "Ish maydoni",
  "Admin": "Admin",
  "Profile": "Profil",
  "Settings": "Sozlamalar",
  "Help": "Yordam",
  "Notifications": "Bildirishnomalar",
  "Annotator": "Annotator",
  "Annotators": "Annotatorlar",
  "Reviewer": "Tekshiruvchi",
  "Reviewers": "Tekshiruvchilar",
  "Super Checker": "Super tekshiruvchi",
  "Super Checkers": "Super tekshiruvchilar",
  "Managers": "Menejerlar",
  "Members": "A'zolar",
  "User Options": "Foydalanuvchi menyusi",
  "User Details": "Foydalanuvchi ma'lumotlari",
  "User Settings": "Foydalanuvchi sozlamalari",
  "App Settings": "Ilova sozlamalari",
  "App Information": "Ilova haqida",
  "Signed in as": "Kirdingiz:",
  "Feedback": "Fikr-mulohaza",

  // --- holatlar / bosqichlar ---
  "Annotation": "Annotatsiya",
  "Review": "Tekshirish",
  "Supercheck": "Super tekshirish",
  "SuperCheck": "Super tekshirish",
  "Super Check": "Super tekshirish",
  "Annotation Stage": "Annotatsiya bosqichi",
  "Review Stage": "Tekshirish bosqichi",
  "Super Check Stage": "Super tekshirish bosqichi",
  "Super-Check Stage": "Super tekshirish bosqichi",
  "All Stage": "Barcha bosqichlar",
  "Validated No Changes": "O'zgarishsiz qabul qilingan",
  "Validated with Changes": "O'zgarish bilan qabul qilingan",

  // --- vazifalar / loyiha ---
  "Tasks": "Vazifalar",
  "All Tasks": "Barcha vazifalar",
  "Task Count": "Vazifalar soni",
  "Task Details": "Vazifa ma'lumotlari",
  "Task ID": "Vazifa ID",
  "Task Status :": "Vazifa holati:",
  "Annotation Tasks": "Annotatsiya vazifalari",
  "Review Tasks": "Tekshirish vazifalari",
  "Super Check Tasks": "Super tekshirish vazifalari",
  "Task Reviews": "Vazifa tekshiruvlari",
  "Task Analytics": "Vazifa tahlili",
  "Tasks Dashboard": "Vazifalar paneli",
  "Unassigned Task": "Biriktirilmagan vazifa",
  "Unassigned Annotation Tasks": "Biriktirilmagan annotatsiya vazifalari",
  "Unassigned Review Tasks": "Biriktirilmagan tekshirish vazifalari",
  "Unassigned Super Check Tasks": "Biriktirilmagan super tekshirish vazifalari",
  "Total Labeled Task": "Jami belgilangan vazifalar",
  "Reviewed Task Count": "Tekshirilgan vazifalar",
  "Pending Review Tasks": "Tekshiruvdagi vazifalar",
  "Pending Supercheck Tasks": "Super tekshiruvdagi vazifalar",
  "Review Completed Task": "Tekshiruv yakunlandi",
  "SuperCheck Completed Tasks": "Super tekshiruv yakunlandi",
  "Total Tasks Count": "Jami vazifalar",
  "Total Annotated Tasks": "Jami annotatsiya qilingan vazifalar",
  "Queued Tasks Status": "Navbatdagi vazifalar holati",
  "Queued Task Details": "Navbatdagi vazifa ma'lumotlari",
  "No Queued Tasks to Display": "Navbatda vazifalar yo'q",
  "Fetch Task Details": "Vazifa ma'lumotlarini olish",
  "Project Page": "Loyiha sahifasi",
  "Project ID": "Loyiha ID",
  "Project Id": "Loyiha ID",
  "Project Name": "Loyiha nomi",
  "Project Title": "Loyiha nomi",
  "Project Type": "Loyiha turi",
  "Project Type:": "Loyiha turi:",
  "Project Type :": "Loyiha turi:",
  "Project Stage": "Loyiha bosqichi",
  "Project stage": "Loyiha bosqichi",
  "Project Stage:": "Loyiha bosqichi:",
  "Project Description": "Loyiha tavsifi",
  "Project Mode": "Loyiha rejimi",
  "Project Settings": "Loyiha sozlamalari",
  "Project Analytics": "Loyiha tahlili",
  "Project Report Type": "Loyiha hisobot turi",
  "Project Reports": "Loyiha hisobotlari",
  "Project Task IDs:": "Loyiha vazifa ID lari:",
  "Project User Type:": "Loyihadagi rol:",
  "Project User Type :": "Loyihadagi rol:",
  "Archived Projects:": "Arxivlangan loyihalar:",
  "Archived Projects :": "Arxivlangan loyihalar:",
  "Target Language": "Til",
  "Target language": "Til",
  "Target Language:": "Til:",
  "Source Language": "Manba tili",
  "Source Language:": "Manba tili:",
  "Output Language :": "Chiqish tili:",
  "Workspace Id": "Ish maydoni ID",
  "Workspace Name": "Ish maydoni nomi",
  "Workspace Name :": "Ish maydoni nomi:",
  "Workspace Settings": "Ish maydoni sozlamalari",
  "Workspace 1": "Ish maydoni 1",

  // --- loyiha tugmalari / paketlar ---
  "Add New Annotation Project": "Yangi annotatsiya loyihasi",
  "Add New Collection Project": "Yangi to'plash loyihasi",
  "Create a Project": "Loyiha yaratish",
  "Create Project": "Loyiha yaratish",
  "Create new account": "Hisob yaratish",
  "Pull New Batch": "Vazifalar paketini olish",
  "Pull New Data Items": "Yangi ma'lumotlarni olish",
  "Pull New Data Items from Source Dataset": "Manba to'plamdan yangi elementlarni olish",
  "Pull Size": "Paket hajmi",
  "Pull Status:": "Tanlov holati:",
  "De-allocate Tasks": "Vazifalarni bo'shatish",
  "Deallocate User Tasks": "Foydalanuvchi vazifalarini bo'shatish",
  "Deallocate by Task ID": "Vazifa ID bo'yicha bo'shatish",
  "Deallocate by user ID": "Foydalanuvchi ID bo'yicha bo'shatish",
  "Delete Project Tasks": "Loyiha vazifalarini o'chirish",
  "Publish Project": "Loyihani nashr qilish",
  "Publish this project to make it live": "Loyihani faollashtirish uchun nashr qiling",
  "Export Project into Dataset": "Loyihani to'plamga eksport qilish",
  "Export all annotated tasks into an output dataset": "Barcha annotatsiya vazifalarini to'plamga eksport qilish",
  "Assign Managers": "Menejerlarni tayinlash",
  "Start Labelling Now": "Annotatsiyani boshlash",
  "Start reviewing now": "Tekshirishni boshlash",
  "Start validating now": "Super tekshirishni boshlash",

  // --- filtrlar ---
  "Pick Dates": "Sanalarni tanlash",
  "Select Report Type :": "Hisobot turi:",
  "Report Type": "Hisobot turi",
  "Report Level": "Hisobot darajasi",
  "Reports": "Hisobotlar",
  "Projects Filter": "Loyihalar filtri",
  "Filter by Task Type": "Vazifa turi bo'yicha filtr",
  "Filter by Annotator": "Annotator bo'yicha filtr",
  "Filter by Reviewer": "Tekshiruvchi bo'yicha filtr",
  "Filter by SuperChecker": "Super tekshiruvchi bo'yicha filtr",
  "Select Task Statuses": "Vazifa holatlarini tanlang",
  "Select Annotation Status :": "Annotatsiya holati:",
  "Select Review Status :": "Tekshiruv holati:",
  "Select Super Check Status :": "Super tekshiruv holati:",
  "Annotation Status:": "Annotatsiya holati:",
  "Review Status:": "Tekshiruv holati:",
  "Supercheck Status:": "Super tekshiruv holati:",
  "Rejected:": "Rad etilgan:",
  "Select user role": "Rolni tanlang",
  "Assigned User:": "Tayinlangan foydalanuvchi:",
  "Select User:": "Foydalanuvchini tanlang:",

  // --- transkripsiya muharriri ---
  "Back to Project": "Loyihaga qaytish",
  "Draft": "Qoralama",
  "Next": "Keyingi",
  "Skip": "O'tkazib yuborish",
  "Skip to next task": "Keyingi vazifaga o'tish",
  "Go to next task": "Keyingi vazifa",
  "Submit task": "Vazifani yuborish",
  "Accept": "Qabul qilish",
  "Revise": "Qayta ishlashga",
  "Revise Annotation": "Qayta ishlashga qaytarish",
  "Accept Annotation": "Annotatsiyani qabul qilish",
  "Review Notes": "Tekshiruv izohlari",
  "Annotation Notes": "Annotatsiya izohlari",
  "Super Checker Notes": "Super tekshiruv izohlari",
  "SuperChecker Notes": "Super tekshiruv izohlari",
  "Place your remarks here ...": "Izoh qoldiring…",
  "Place your remarks here...": "Izoh qoldiring…",
  "Notes": "Izohlar",
  "Glossary": "Lug'at",
  "Select Noise Tag": "Shovqin belgisi",
  "Select Tag": "Belgini tanlang",
  "Select Speaker": "So'zlovchini tanlang",
  "Subtitles": "Subtitrlar",
  "Add Subtitle Box": "Segment qo'shish",
  "Split Subtitle": "Segmentni bo'lish",
  "Delete Subtitle": "Segmentni o'chirish",
  "Subtitle Preview": "Segment ko'rinishi",
  "Timeline Scale:": "Yo'lak masshtabi:",
  "Playback Speed:": "Ijro tezligi:",
  "Playback Speed": "Ijro tezligi",
  "Repeat Count:": "Takrorlar:",
  "Play Once": "Bir marta",
  "Repeat 1x": "1x takror",
  "Repeat 2x": "2x takror",
  "Infinite": "Cheksiz",
  "Scale": "Masshtab",
  "Hotkeys": "Tezkor tugmalar",
  "Font Size": "Shrift o'lchami",
  "Undo": "Bekor qilish",
  "Redo": "Qaytarish",
  "RTL Typing": "O'ngdan chapga yozish",
  "Enable RTL-typing": "O'ngdan chapga yozish",
  "Pause when typing": "Yozganda to'xtatish",
  "Advanced Settings": "Qo'shimcha sozlamalar",
  "Verbatim Transcription": "So'zma-so'z transkripsiya",
  "Semantic (L2) Transcription": "Normallashtirilgan (L2) transkripsiya",
  "Standardised Transcription": "Standartlashtirilgan transkripsiya",
  "Auto-save enabled for this scenario.": "Avtomatik saqlash yoqilgan.",
  "Auto-save is enabled for this scenario.": "Avtomatik saqlash yoqilgan.",
  "Hide Additional Options": "Qo'shimcha imkoniyatlarni yashirish",
  "Show Additional Options": "Qo'shimcha imkoniyatlarni ko'rsatish",
  "Loading task data...": "Vazifa yuklanmoqda…",
  "Recognized Text": "Tanilgan matn",

  // --- ma'lumot to'plamlari ---
  "Datasets": "Ma'lumot to'plamlari",
  "Dataset ID": "To'plam ID",
  "Dataset Id": "To'plam ID",
  "Dataset Name": "To'plam nomi",
  "Dataset Title": "To'plam nomi",
  "Dataset Type": "To'plam turi",
  "Dataset Type:": "To'plam turi:",
  "Dataset Type :": "To'plam turi:",
  "Datset Type": "To'plam turi",
  "Dataset Description": "To'plam tavsifi",
  "Dataset Visibility:": "To'plam ko'rinishi:",
  "Dataset Visibility :": "To'plam ko'rinishi:",
  "Dataset Instance Id": "To'plam nusxasi ID",
  "Dataset Instance :": "To'plam nusxasi:",
  "Create New Dataset Instance": "Yangi to'plam",
  "Automate Datasets": "To'plamlarni avtomatlashtirish",
  "Upload Data": "Ma'lumot yuklash",
  "Upload": "Yuklash",
  "Select File :": "Faylni tanlang:",
  "Select File Format :": "Fayl formati:",
  "Delete Duplicate Records :": "Takrorlarni o'chirish:",
  "DataSet Settings": "To'plam sozlamalari",
  "Deduplicate Data Items": "Takrorlarni olib tashlash",
  "Delete Data Item": "Ma'lumot elementini o'chirish",
  "Delete by Range": "Diapazon bo'yicha o'chirish",
  "Delete by IDs": "ID bo'yicha o'chirish",
  "Start Data ID:": "Boshlang'ich ID:",
  "End Data ID:": "Yakuniy ID:",
  "Data IDs:": "Ma'lumot ID lari:",
  "Download DataSet": "To'plamni yuklab olish",
  "Download Metadata": "Metama'lumotni yuklab olish",
  "Select dataset type:": "To'plam turi:",
  "Select Field:": "Maydon:",
  "Instance ID :": "Nusxa ID:",
  "Description :": "Tavsif:",

  // --- loyiha yaratish ---
  "Title:": "Nomi:",
  "Description:": "Tavsif:",
  "Select a Category to Work in:": "Kategoriyani tanlang:",
  "Select a Project Type:": "Loyiha turini tanlang:",
  "Finalize Project": "Yaratishni yakunlash",
  "Variable Parameters": "O'zgaruvchan parametrlar",
  "Variable Parameters:": "O'zgaruvchan parametrlar:",
  "Sampling Parameters": "Tanlash parametrlari",
  "Sampling Mode :": "Tanlash rejimi:",
  "Select Sampling Type:": "Tanlash turi:",
  "Sampling Percentage:": "Tanlash foizi:",
  "Filter String :": "Filtr satri:",
  "Filter String:": "Filtr satri:",
  "Dataset Rows:": "To'plam satrlari:",
  "Select sources to fetch data from:": "Ma'lumot manbalarini tanlang:",
  "Annotators Per Task:": "Har vazifaga annotatorlar:",
  "Tasks per batch:": "Bir martada vazifalar (partiya):",
  "Create Annotations Automatically:": "Annotatsiyani avtomatik yaratish:",
  "Acoustic Enabled Stage:": "Akustik normallashtirish bosqichi:",
  "Max Pending Tasks Per User": "Foydalanuvchida maks. vazifalar",
  "Tasks Pull Count Per Batch": "Bir paketdagi vazifalar",
  "Enter source language": "Manba tili",
  "Change Sources": "Manbalarni o'zgartirish",

  // --- hisobotlar / tahlil ---
  "Analytics": "Tahlil",
  "Analytics Type": "Tahlil turi",
  "Statistics": "Statistika",
  "Total Summary": "Yakun",
  "High-Level Reports": "Umumiy hisobotlar",
  "Detailed Reports": "Batafsil hisobotlar",
  "Annotation Statistics": "Annotatsiya statistikasi",
  "Complete Statistics": "To'liq statistika",
  "Meta Analytics": "Meta-tahlil",
  "Advance Analytics": "Kengaytirilgan tahlil",
  "Performance Analytics": "Samaradorlik tahlili",
  "Base period": "Asosiy davr",
  "Comparison Period": "Taqqoslash davri",
  "Individual": "Alohida",
  "Comparison": "Taqqoslash",
  "Cumulative": "Jami",
  "Daily": "Kunlik",
  "Weekly": "Haftalik",
  "Monthly": "Oylik",
  "This Year": "Shu yil",
  "Last Year": "O'tgan yil",
  "Till Date": "Shu kungacha",
  "Total Audio Hours": "Jami audio soatlar",
  "Total Annotation Audio Hours": "Annotatsiya audio soatlari",
  "Total Reviewed AudioHours": "Tekshirilgan audio soatlar",
  "Total Annotated Count": "Jami annotatsiya qilingan",
  "Total Audio Files Annotated": "Annotatsiya qilingan audiofayllar",
  "Users Reports": "Foydalanuvchi hisobotlari",
  "Payment Reports": "To'lov hisobotlari",
  "Download Report As PDF": "Hisobotni yuklab olish (PDF)",
  "Download Report As Image": "Hisobotni yuklab olish (rasm)",

  // --- tashkilot / ish maydoni / foydalanuvchilar ---
  "Workspaces": "Ish maydonlari",
  "Invites": "Takliflar",
  "Logs": "Jurnal",
  "Add New Workspace": "Ish maydoni qo'shish",
  "Add Members to Workspace": "Ish maydoniga a'zolar qo'shish",
  "Add Annotators to Workspace": "Ish maydoniga annotatorlar qo'shish",
  "Add Users": "Foydalanuvchilar qo'shish",
  "Add User": "Foydalanuvchi qo'shish",
  "Nickname": "Nik (ko'rinadigan nom)",
  "Nickname hint": "Bo'sh qoldirilsa — avtomatik yaratiladi. Noyob bo'lishi kerak.",
  "Edit user": "Foydalanuvchini tahrirlash",
  "Workspace Manager": "Ish maydoni menejeri",
  "Select Users...": "Foydalanuvchilarni tanlang…",
  "Select users to be added.": "Qo'shiladigan foydalanuvchilarni tanlang.",
  "Invite Users to Organisation": "Foydalanuvchilarni tashkilotga taklif qilish",
  "Invite Users to Organization": "Foydalanuvchilarni tashkilotga taklif qilish",
  "Add Members to Dataset": "To'plamga a'zolar qo'shish",
  "Add Annotators to Project": "Loyihaga annotatorlar qo'shish",
  "Add Reviewers to Project": "Loyihaga tekshiruvchilar qo'shish",
  "Add SuperChecker to Project": "Loyihaga super tekshiruvchi qo'shish",
  "Invite new members to organization": "Tashkilotga a'zolar taklif qilish",
  "Invited Users": "Taklif qilingan foydalanuvchilar",
  "Invited By": "Taklif qilgan",
  "Enter email ids of users to invite": "Taklif qilinadigan foydalanuvchilar emailini kiriting",
  "Email ids": "Email manzillar",
  "Manager Suggestions": "Tavsiya etilgan menejerlar",
  "Edit Organization": "Tashkilotni tahrirlash",
  "Organization Name...": "Tashkilot nomi…",
  "Archive Workspace": "Ish maydonini arxivlash",
  "Public Analytics": "Ommaviy tahlil",
  "Enter workspace details": "Ish maydoni ma'lumotlari",
  "Visit Workspaces": "Ish maydonlariga",
  "Preferred Workspaces": "Afzal ish maydonlari",
  "Participation Type": "Ishtirok turi",
  "Participation Types": "Ishtirok turlari",
  "Full-time": "To'liq bandlik",
  "Part-time": "Qisman bandlik",
  "Contract-Basis": "Shartnoma asosida",

  // --- profil / parol / kirish ---
  "Change Password": "Parolni o'zgartirish",
  "Current Password": "Joriy parol",
  "New Password": "Yangi parol",
  "Confirm Password": "Parolni tasdiqlang",
  "Enter Current Password": "Joriy parolni kiriting",
  "Re-enter your Password": "Parolni takrorlang",
  "Both password must match.": "Parollar mos kelishi kerak.",
  "Forgot password?": "Parolni unutdingizmi?",
  "New to CSI Annotator ?": "CSI Annotator'da yangimisiz?",
  "Already have an account ?": "Hisobingiz bormi?",
  "Profile Details": "Profil ma'lumotlari",
  "My Progress": "Mening jarayonim",
  "View Progress": "Jarayonni ochish",
  "Recent Tasks": "So'nggi vazifalar",
  "Daily Mails": "Kunlik xatlar",
  "Schedule": "Jadval",
  "Day of Week": "Hafta kuni",
  "Day of Month": "Oy kuni",
  "Sunday": "Yakshanba",
  "Monday": "Dushanba",
  "Tuesday": "Seshanba",
  "Wednesday": "Chorshanba",
  "Thursday": "Payshanba",
  "Friday": "Juma",
  "Saturday": "Shanba",

  // --- bildirishnomalar ---
  "Mark as read": "O'qilgan deb belgilash",
  "Mark as Read": "O'qilgan deb belgilash",
  "Mark all as read": "Barchasini o'qilgan deb belgilash",
  "Mark All as read": "Barchasini o'qilgan deb belgilash",
  "Unread": "O'qilmagan",
  "No notifications found": "Bildirishnomalar yo'q",
  "No notifications available": "Bildirishnomalar yo'q",
  "No unread notifications": "O'qilmagan bildirishnomalar yo'q",

  // --- boshqa / jadvallar ---
  "Jump to Page:": "Sahifaga o'tish:",
  "No results": "Natija yo'q",
  "No table data found": "Jadval ma'lumoti yo'q",
  "List": "Ro'yxat",
  "Card": "Kartochka",
  "List view": "Ro'yxat ko'rinishi",
  "Card view": "Kartochka ko'rinishi",
  "View Columns": "Ustunlar",
  "Filter Table": "Jadval filtri",
  "Select Language:": "Til:",
  "Select Language": "Tilni tanlang",
  "Enter text here...": "Matn kiriting…",
  "Loading....": "Yuklanmoqda…",
  "Please do not add notes if you are going to skip the task!": "Vazifani o'tkazib yubormoqchi bo'lsangiz izoh qo'shmang!",
  "Fetch Annotation Details": "Annotatsiya ma'lumotlarini olish",
  "Annotation ID": "Annotatsiya ID",
  "Annotation Details": "Annotatsiya ma'lumotlari",
  "Annotations": "Annotatsiya",
  "Super Check Settings": "Super tekshirish sozlamalari",
  "Download All Projects": "Barcha loyihalarni yuklab olish",
  "View Dataset": "To'plamni ochish",
  "View Workspace": "Ish maydonini ochish",
  "Add Glossary": "Lug'atga qo'shish",
  "Source Text": "Manba matni",
  "Target Text": "Maqsad matni",
  "Source": "Manba",
  "Target": "Maqsad",
  "Are you sure want to Deallocate User Tasks ?": "Foydalanuvchi vazifalarini bo'shatishga ishonchingiz komilmi?",
  // --- Отчёты / аналитика: заголовки столбцов ---
  "Annotation Report": "Belgilash hisoboti",
  "Reviewer Report": "Tekshiruvchi hisoboti",
  "Super Checker Report": "Super tekshiruvchi hisoboti",
  "Reviewer Name": "Tekshiruvchi ismi",
  "Assigned": "Tayinlangan",
  "Labeled": "Belgilangan",
  "Unlabeled": "Belgilanmagan",
  "Skipped": "O'tkazib yuborilgan",
  "Rejected Files": "Rad etilgan fayllar",
  "Reject File": "Faylni rad etish",
  "File does not meet requirements": "Fayl talablarga mos emas",
  "Reject file hint manager": "Fayl talablarga mos emasmi? Sababini ko'rsating — fayl darhol ishdan chiqariladi va annotatorlarga berilmaydi. U «Rad etilgan fayllar» bo'limida «Chiqarilgan» holatida ko'rinadi.",
  "Reject file hint": "Fayl talablarga mos emasmi? Sababini ko'rsating — u menejer tekshiruviga yuboriladi va sizning vazifalaringizdan chiqadi. Agar menejer rozi bo'lmasa, fayl umumiy fondga qaytariladi.",
  "Wrong language": "Til noto'g'ri",
  "Poor quality / noise": "Sifat past / shovqin",
  "Empty recording": "Bo'sh yozuv",
  "Off topic": "Mavzuga oid emas",
  "Duplicate": "Dublikat",
  "Other": "Boshqa",
  "Comment": "Izoh",
  "Comment (required)": "Izoh (majburiy)",
  "Awaiting decision": "Qaror kutilmoqda",
  "Excluded": "Chiqarilgan",
  "Rejected files hint": "Annotatorlar talablarga mos emas deb belgilagan fayllar. Rad etishni tasdiqlang (fayl chiqariladi) yoki faylni umumiy fondga qaytaring.",
  "Total": "Jami",
  "File": "Fayl",
  "Reason": "Sabab",
  "Rejected by": "Rad etdi",
  "When": "Qachon",
  "Return to pool": "Umumiy fondga qaytarish",
  "Network error": "Tarmoq xatosi",
  "Network error while rejecting the file": "Faylni rad etishda tarmoq xatosi",
  // Сообщения бэкенда фичи отклонения (ключ на русском → узбекский текст).
  "Файл отправлен на проверку менеджеру": "Fayl menejer tekshiruviga yuborildi",
  "Файл исключён из работы": "Fayl ishdan chiqarildi",
  "Не удалось отклонить файл": "Faylni rad etib bo'lmadi",
  "Вы не назначены аннотатором этой задачи":
    "Siz bu vazifaga annotator sifatida tayinlanmagansiz",
  "Файл уже отправлен на проверку менеджеру":
    "Fayl allaqachon menejer tekshiruviga yuborilgan",
  "Некорректная причина отклонения": "Rad etish sababi noto'g'ri",
  "Отклонение подтверждено, файл исключён":
    "Rad etish tasdiqlandi, fayl chiqarildi",
  "Файл возвращён в общий пул": "Fayl umumiy fondga qaytarildi",
  "Недостаточно прав для рассмотрения отклонения":
    "Rad etishni ko'rib chiqish uchun huquq yetarli emas",
  "Нет отклонения, ожидающего рассмотрения":
    "Ko'rib chiqishni kutayotgan rad etish yo'q",
  "Некорректное действие": "Noto'g'ri amal",
  "Reviewed": "Tekshirilgan",
  "UnReviewed": "Tekshirilmagan",
  "Accepted": "Qabul qilingan",
  "Rejected": "Rad etilgan",
  "Accepted With Minor Changes": "Kichik o'zgarishlar bilan qabul qilingan",
  "Accepted With Major Changes": "Katta o'zgarishlar bilan qabul qilingan",
  "(Accepted/Reviewed) Percentage": "Qabul ulushi (qabul/tekshirilgan)",
  "Annotated Tasks": "Belgilangan vazifalar",
  "Reviewed Tasks": "Tekshirilgan vazifalar",
  "SuperChecked Tasks": "Super tekshirilgan vazifalar",
  "Submitted Tasks": "Yuborilgan vazifalar",
  "Annotation Tasks Assigned": "Tayinlangan belgilash vazifalari",
  "No. of Annotators Assigned": "Tayinlangan belgilovchilar soni",
  "No .of Annotators Assigned": "Tayinlangan belgilovchilar soni",
  "Total Segments Duration": "Segmentlarning umumiy davomiyligi",
  "Total Raw Audio Duration": "Audioning umumiy davomiyligi",
  "Avg Segment Duration": "O'rtacha segment davomiyligi",
  "Average Segments Per Task": "Har vazifadagi o'rtacha segmentlar soni",
  "Average Word Error Rate A/R": "O'rtacha WER (belgilovchi/tekshiruvchi)",
  "Average Word Error Rate R/S": "O'rtacha WER (tekshiruvchi/super)",
  "Average Annotation Time (In Seconds)": "O'rtacha belgilash vaqti (soniya)",
  "Avg Annotation Time (sec)": "O'rtacha belgilash vaqti (soniya)",
  "Word Count": "So'zlar soni",
  "Total Word Count": "Jami so'zlar",
  "Raw Audio Duration": "Audio davomiyligi",
  "Segment Duration": "Segment davomiyligi",
  "Not Null Segment Duration": "Nolga teng bo'lmagan segment davomiyligi",
  "Annotated Tasks Audio Duration": "Belgilangan vazifalar audio davomiyligi",
  "Annotated Tasks Segments Duration": "Belgilangan vazifalar segment davomiyligi",
  "Annotated Tasks Word Count": "Belgilangan vazifalar so'zlar soni",
  "Reviewed Tasks Audio Duration": "Tekshirilgan vazifalar audio davomiyligi",
  "Reviewed Tasks Segments Duration": "Tekshirilgan vazifalar segment davomiyligi",
  "Reviewed Tasks Word Count": "Tekshirilgan vazifalar so'zlar soni",
  "SuperChecked Tasks Audio Duration": "Super tekshirilgan vazifalar audio davomiyligi",
  "SuperChecked Tasks Segments Duration": "Super tekshirilgan vazifalar segment davomiyligi",
  "SuperChecked Tasks Word Count": "Super tekshirilgan vazifalar so'zlar soni",
  "Exported Tasks Audio Duration": "Eksport qilingan vazifalar audio davomiyligi",
  "Exported Tasks Segments Duration": "Eksport qilingan vazifalar segment davomiyligi",
  "Exported Tasks Word Count": "Eksport qilingan vazifalar so'zlar soni",
  "Rejected Audio Duration": "Rad etilganlar audio davomiyligi",
  "Rejected Segments Duration": "Rad etilganlar segment davomiyligi",
  "Rejected Word Count": "Rad etilganlar so'zlar soni",
  "Annotator - Unassigned Tasks": "Belgilovchi — tayinlanmagan vazifalar",
  "Reviewer - Unassigned Tasks": "Tekshiruvchi — tayinlanmagan vazifalar",
  "Superchecker - Unassigned Tasks": "Super — tayinlanmagan vazifalar",
  "Average Annotator VS Reviewer Word Error Rate": "O'rtacha WER: belgilovchi va tekshiruvchi",
  "Average Annotator VS Reviewer Character Edit Distance": "O'rtacha tahrir masofasi (belgi): belgilovchi va tekshiruvchi",
  "Average Annotator VS Superchecker Word Error Rate": "O'rtacha WER: belgilovchi va super",
  "Average Annotator VS Superchecker Character Edit Distance": "O'rtacha tahrir masofasi (belgi): belgilovchi va super",
  "Average Reviewer VS Superchecker Word Error Rate": "O'rtacha WER: tekshiruvchi va super",
  "Average Reviewer VS Superchecker Character Edit Distance": "O'rtacha tahrir masofasi (belgi): tekshiruvchi va super",
  "Average Bleu Score Annotator Vs Reviewer": "O'rtacha BLEU: belgilovchi va tekshiruvchi",
  "Average Bleu Score Reviewer Vs Superchecker": "O'rtacha BLEU: tekshiruvchi va super",
  "Average Rejection Count Annotator Vs Reviewer": "O'rtacha rad etishlar: belgilovchi va tekshiruvchi",
  "Average Rejection Count Reviewer Vs Superchecker": "O'rtacha rad etishlar: tekshiruvchi va super",
  "Cumulative Word Error Rate Annotator Vs Reviewer": "Jami WER: belgilovchi va tekshiruvchi",
  "Cumulative Word Error Rate Annotator Vs Superchecker": "Jami WER: belgilovchi va super",
  "Cumulative Word Error Rate Reviewer Vs Superchecker": "Jami WER: tekshiruvchi va super",
  // --- Audio belgilash muharriri ---
  "Task": "Vazifa",
  "Double-click on any segment in the audio waveform to play it in a loop": "Segmentni tsiklda ijro etish uchun to'lqin shaklidagi segmentni ikki marta bosing",

  // --- Таблица задач: столбцы, статусы, действия ---
  "Scenario": "Ssenariy",
  "Audio Duration": "Audio davomiyligi",
  "Reference Raw Transcript": "Namunaviy dastlabki matn",
  "Annotator Email": "Belgilovchi e-pochtasi",
  "Speakers Json": "Soʻzlovchilar (JSON)",
  "Machine Transcribed Json": "Mashina transkripsiyasi (JSON)",
  "Audio Url": "Audio havolasi",
  "Annotate": "Belgilash",
  "Edit": "Tahrirlash",
  "unlabeled": "belgilanmagan",
  "labeled": "belgilangan",
  "skipped": "o'tkazib yuborilgan",
  "draft": "qoralama",
  "unreviewed": "tekshirilmagan",
  "accepted": "qabul qilingan",
  "to_be_revised": "qayta ishlanadi",
  "accepted_with_minor_changes": "kichik o'zgarishlar bilan qabul qilingan",
  "accepted_with_major_changes": "katta o'zgarishlar bilan qabul qilingan",
  "unvalidated": "tasdiqlanmagan",
  "validated": "tasdiqlangan",
  "validated_with_changes": "o'zgarishlar bilan tasdiqlangan",
  "rejected": "rad etilgan",
  "incomplete": "tugallanmagan",
  "annotated": "belgilangan",
  "reviewed": "tekshirilgan",
  "exported": "eksport qilingan",
  "freezed": "muzlatilgan",
  "super_checked": "super tekshirilgan",
  "Published": "Chop etilgan",
  "Archived": "Arxivlangan",

  // --- Панель спикеров / шум сегмента ---
  "Speakers": "So'zlovchilar",
  "Speaker Name": "Ism",
  "Add speaker": "So'zlovchi qo'shish",
  "Delete speaker": "So'zlovchini o'chirish",
  "Gender": "Jinsi",
  "Age": "Yosh",
  "Region": "Hudud",
  "Noise": "Shovqin",
  "no noise": "yo'q",
  "low": "past",
  "medium": "o'rta",
  "high": "baland",
  "male": "erkak",
  "female": "ayol",
  "unknown": "noma'lum",

  // --- Метаданные записи ---
  "Recording metadata": "Yozuv metama'lumotlari",
  "Dialect": "Sheva",
  "Quality": "Sifat",
  "not set": "belgilanmagan",
  "good": "yaxshi",
  "average": "o'rtacha",
  "poor": "yomon",
  "Usable": "Yaroqli",
  "Yes": "Ha",
  "No": "Yo'q",
  "Reject reason": "Brak sababi",
  "Topic": "Mavzu",
  "Recording date": "Yozuv sanasi",
  "Add first segment": "Birinchi segment qo'shish",
  "No segments yet — add one to start transcribing.": "Segmentlar yo'q — transkripsiyani boshlash uchun bittasini qo'shing.",
  "Recognize whole file (ASR)": "Butun faylni tanish (ASR)",
  "Recognize segment (ASR)": "Segmentni tanish (ASR)",
  "Recognizing…": "Tanilmoqda…",
  "Recognize whole file confirm":
    "Butun fayl qayta tanilsinmi? Joriy belgilash ASR natijasi bilan almashtiriladi.",
  "ASR segment failed": "Segmentni tanib bo'lmadi",
  "ASR whole file failed": "Faylni qayta ishlash muvaffaqiyatsiz tugadi",
  "ASR returned no segments": "ASR segment qaytarmadi",
  "ASR timeout": "Tanish belgilangan vaqtda tugamadi",
  "ASR service busy":
    "ASR xizmati hozir band (fonda oldindan belgilash ketmoqda) yoki javob bermadi — keyinroq urinib ko'ring.",
  "My tasks total": "Mening vazifalarim — jami",
  "Assigned not started": "Tayinlangan (boshlanmagan)",
  "In progress draft": "Ishlanmoqda (qoralama)",
  "Labeled by me": "Belgilangan",
  "Returned for revision": "Qayta ishlashga",
  "min": "daq",
  "h": "soat",
  "To review": "Tekshirishga",
  "Accepted": "Qabul qilingan",
  "Sent for revision": "Qayta ishlashga yuborilgan",
  "To super check": "Super tekshirishga",
  "Validated": "Tasdiqlangan",
  "Rejected": "Rad etilgan",
  "My Progress": "Mening jarayonim",
  "Progress of": "Jarayoni:",
  "Updated at": "Yangilangan",
  "Annotated at": "Belgilangan",
  "Created at": "Yaratilgan",
  "When task was last updated": "Vazifa oxirgi marta qachon yangilangan",
  "When task was assigned": "Vazifa qachon tayinlangan",
  "When task was first annotated": "Vazifa birinchi marta qachon belgilangan",
  "Not Authorised to View Details": "Ma'lumotlarni ko'rishga ruxsat yo'q",
  "Assign to user": "Bajaruvchiga tayinlash",
  "Choose who gets the selected tasks": "Tanlangan vazifalar kimga berilishini tanlang",
  "Assign": "Tayinlash",
  "Submit for review": "Tekshiruvga topshirish",
  "Submit for review hint": "Ishni tekshiruvchiga yuborish",
  "Emotion": "Ohang/hissiyot",
  "neutral": "Neytral",
  "happy": "Xursandchilik",
  "sad": "Qayg'u",
  "angry": "Jahl",
  "surprised": "Hayrat",
  "fearful": "Qo'rquv",
  "disgusted": "Nafrat",
  "Split at cursor": "Kursor bo'yicha bo'lish",
  "Place cursor in text to split": "Bo'lish uchun matnga kursor qo'ying",
  "Uploaded Date": "Yuklangan sana",
  "Annotated Date": "Bajarilgan sana",
  "Reviewed Date": "Tekshirilgan sana",
  "Superchecked Date": "Super tekshiruv",
  "Open": "Ochish",
  "Menu": "Menyu",
  "Submitted": "Topshirilgan",
  "Changes summary": "O'zgarishlar xulosasi",
  "Edit log": "Tahrirlar jurnali",
  "No edits recorded": "Tahrirlar qayd etilmagan",
  "changed": "o'zgargan",
  "and": "va yana",
  "Changed at this stage": "Ushbu bosqichda o'zgartirilgan",
  "Submitted by annotator": "Annotator topshirgan",
  "Segment": "Segment",
  "verbatim text is empty": "so'zma-so'z matn to'ldirilmagan",
  "normalized text is empty": "normallashtirilgan (L2) matn to'ldirilmagan",
  "speaker is not selected": "so'zlovchi tanlanmagan",
  "Error in saving annotation": "Belgilashni saqlab bo'lmadi",
  "Please select dates upto Today": "Bugungi kundan keyingi sanani tanlab bo'lmaydi",
  "Invalid Date Format": "Sana formati noto'g'ri",
  "Status timeline": "Holatlar lentasi",
  "Task History": "Vazifa tarixi",
  "Send for revision": "Qayta ishlashga yuborish",
  "Choose who will rework the task": "Vazifani kim qayta ishlashini tanlang",
  "Assignee": "Bajaruvchi",
  "current": "hozirgi",
  "To start": "Boshiga",
  "To end": "Oxiriga",
  "Rewind": "Orqaga",
  "Forward": "Oldinga",
  "sec": "s",
  "Play": "Ijro",
  "Pause": "To'xtatish",
  "Zoom in": "Masshtabni kattalashtirish",
  "Zoom out": "Masshtabni kichiklashtirish",
  "Important dates": "Muhim sanalar",
  "Status history": "Holatlar tarixi",
  "Uploaded date": "Yuklangan sana",
  "Modified date": "O'zgartirilgan sana",
  "Sent for review date": "Tekshiruvga yuborilgan sana",
  "Completed date": "Bajarilgan sana",
  "Sent for revision date": "Qayta ishlashga yuborilgan sana",
  "Last edited time": "Oxirgi tahrirlangan vaqt",
  "Super check completed date": "Super tekshiruv yakunlangan sana",
  "my.summary.title": "Mening ish hajmim",
  "my.summary.period.today": "Bugun",
  "my.summary.period.week": "Bir hafta",
  "my.summary.stage.annotation": "Belgilash",
  "my.summary.stage.review": "Tekshirish",
  "my.summary.stage.supercheck": "Super tekshirish",
  "my.summary.tasks": "topshirilgan vazifa",
  "my.summary.duration": "audio davomiyligi",
  "my.summary.segments": "segment",
  "my.summary.returned": "qayta ishlashga qaytarilgan",
  "audio.upload.button": "Audio yuklash",
  "audio.upload.title": "Audiofayllarni yuklash",
  "audio.upload.choose": "Fayllarni tanlash",
  "audio.upload.limits": "WAV, mp3, m4a. Bir marta 50 tadan ko'p emas, har biri 100 MB gacha.",
  "audio.upload.selected": "Tanlandi",
  "audio.upload.domain": "Soha",
  "audio.upload.runLlm": "LLM orqali o'tkazish",
  "audio.upload.runLlmHint": "Fayl faqat dastlabki belgilashdan keyin belgilovchilarga ochiladi.",
  "audio.upload.sending": "Fayl uzatilmoqda",
  "audio.upload.start": "Yuklash",
  "audio.upload.done": "Yuklandi",
  "audio.upload.failed": "xatolik bilan",
  "audio.upload.markup": "Razmetka fayli (CSV)",
  "audio.upload.markupHint": "Ixtiyoriy. audio va text ustunli jadval: audio fayl nomi va qoralama matn. Qoralama annotatorning vazifasiga darhol tushadi — qaytadan terish emas, tuzatish kifoya. Xuddi shu nomli avval yuklangan fayllarga ham qo'llanadi, shuning uchun audioni qismlab, razmetkani esa bitta fayl bilan yuklash mumkin.",
  "audio.upload.markupRows": "qator",
  "audio.upload.markupEmpty": "bo'sh matn",
  "audio.upload.markupCovered": "Tanlangan audiolardan razmetkada borlari",
  "audio.upload.markupExisting": "Avval yuklanganlar bilan mosliklar",
  "audio.upload.markupNoLlm": "Razmetkadagi fayllar uchun ASR dastlabki belgilash ishga tushmaydi — qoralama fayldan olinadi.",
  "audio.upload.markupL2": "Qoralamani normallashtirilgan qatlamga (L2) ham nusxalash",
  "audio.upload.markupRemove": "Olib tashlash",
  "audio.upload.markupApplied": "Razmetka qo'llandi",
  "audio.upload.markupNotFound": "datasetda fayli yo'q qatorlar",
  "audio.upload.markupInWork": "annotatorda ishlanmoqda — o'zgartirilmadi",
  "audio.upload.markupAmbiguous": "nom datasetda takrorlanadi — o'zgartirilmadi",
  "audio.upload.markupBusy": "ASR dastlabki belgilash ketmoqda — o'zgartirilmadi",
  "audio.preannotation.title": "Dastlabki belgilash",
  "audio.preannotation.done": "tayyor",
  "audio.preannotation.inQueue": "navbatda",
  "audio.preannotation.failed": "xatolik",
  "audio.preannotation.retry": "Qayta urinish",
  "log.hint": "To'plam bilan bajarilgan fon amallari jurnali: ma'lumot yuklash va loyihalarni chiqarish. LLM dastlabki belgilash holatini «Ma'lumot to'plamlari» yorlig'ida ko'ring.",
  "log.task.upload": "To'plamga ma'lumot yuklash",
  "log.task.exportNew": "Loyihani chiqarish (yangi yozuv sifatida)",
  "log.task.exportInPlace": "Loyihani chiqarish (yozuvlarni yangilash)",
  "log.pre.title": "Dastlabki belgilash jurnali",
  "log.pre.hint": "Har bir urinish alohida satrda, jumladan xatolikdan keyingi takrorlar ham.",
  "log.pre.file": "Fayl",
  "log.pre.attempt": "Urinish",
  "log.pre.segments": "Segmentlar",
  "log.pre.spent": "Ishlov",
  "log.pre.started": "Boshlangan",
  "log.pre.sec": "s",
  "log.pre.status.done": "Tayyor",
  "log.pre.status.failed": "Xatolik",
  "log.pre.status.running": "Bajarilmoqda",
  "col.audioUrl": "Audio havolasi",
  "col.speakerCount": "So'zlovchilar soni",
  "col.speakersJson": "So'zlovchilar",
  "col.metadataJson": "Metama'lumotlar",
  "col.draftDataJson": "Dastlabki belgilash qoralamasi",
  "col.transcribedJson": "Transkripsiya",
  "col.machineTranscribedJson": "Mashina transkripsiyasi",
  "col.finalTranscribedJson": "Yakuniy transkripsiya",
  "col.predictionJson": "Model bashorati",
  "col.preannotationStatus": "Dastlabki belgilash holati",
  "col.preannotationError": "Dastlabki belgilash xatosi",
  "col.preannotationFinishedAt": "Dastlabki belgilash tugagan",
  "col.originalFilename": "Asl fayl nomi",
  "col.instanceId": "To'plam",
  "col.parentData": "Manba yozuv",
  "col.preannotation.none": "Talab qilinmaydi",
  "log.pre.status.pending": "Navbatda",
  "table.showFull": "To'liq ochish",
  "stage.annotationOnly": "Faqat belgilash",
  "stage.reviewEnabled": "Belgilash va tekshirish",
  "stage.supercheckEnabled": "Belgilash, tekshirish, super tekshirish",
  "proj.pullNewData": "Yangi ma'lumotlarni olish",
  "Failed to pull new data items": "Yangi ma'lumotlarni olishda xatolik",
  "create.missing": "Loyiha yaratish uchun to'ldiring",
  "Select Project Type:": "Loyiha turi:",
  "Language:": "Til:",
  "autoAnn.label": "Dastlabki belgilashni tayyor ish sifatida qabul qilish:",
  "autoAnn.none": "Yo'q — odamlar belgilaydi",
  "autoAnn.annotation": "Belgilash bosqichini yopish",
  "autoAnn.review": "Belgilash va tekshirishni yopish",
  "autoAnn.supercheck": "Barcha bosqichlarni yopish",
  "acoustic.label": "Normallashtirilgan matn qaysi bosqichdan mavjud:",
  "acoustic.fromAnnotation": "Belgilashdan",
  "acoustic.fromReview": "Tekshirishdan",
  "acoustic.fromSupercheck": "Super tekshirishdan",
  "project.notPublished": "Loyiha chop etilmagan — vazifalar yaratilgan, lekin ishga berilmaydi.",
  "project.publish": "Chop etish",
  "project.publishFailed": "Loyihani chop etib bo'lmadi",
  "unassigned.tab": "Bo'sh vazifalar",
  "unassigned.hint": "Hali hech kim olmagan vazifalar. Muayyan ijrochiga berish mumkin.",
  "unassigned.free": "Bo'sh",
  "unassigned.choosePerson": "Ijrochini tanlang",
  "unassigned.assign": "Tayinlash",
  "unassigned.assignFailed": "Vazifalarni tayinlab bo'lmadi",
  "unassigned.stage.annotation": "Belgilashga",
  "unassigned.stage.review": "Tekshirishga",
  "unassigned.stage.supercheck": "Super tekshirishga",
  "Version": "Versiya",
  "Frontend": "Frontend",
  "Backend": "Backend",
};

export default uz;
